import { configureStore } from '@reduxjs/toolkit'
import layoutSliceReducer from 'features/layout/layoutSlice'

// We'll use this later to infer the root state from the store.
export const store = configureStore({
	reducer: {
		layout: layoutSliceReducer,
	}
})

// Infer the `RootState` and `AppDispatch` types from the store itself.
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

